import BaseBehavior from '../../../framework/base/base';

export default class TableAccordion extends BaseBehavior {
	constructor(element) {
		super(element);
		this.checkboxInputs = this.element.querySelectorAll('input[type="checkbox"]');
		this.addEventListeners();
	}

	addEventListeners() {
		this.addEventListener(this.element, 'click', el => {
			const self = el.target.type === 'checkbox' ? el.target : null;
			if (self) {
				Array.from(this.element.querySelectorAll('input[type="checkbox"]')).forEach(check => {
					if (check !== self) {
						// eslint-disable-next-line
						check.checked = false;
					}
				});
			}
		});
	}
}
